import { useState, useEffect } from "react";
import { useStateContext } from "../../contexts/ContextProvider";
import Editor from "react-simple-wysiwyg";
import AuthService from "../../services/auth.service";
import LeaveHistoryService from "../../services/leaveHistory.service";

const RejectRequest = ({
  leaveDays,
  selectedRowData,
  setSuccess,
  fetchData,
  setHeading,
}) => {
  const { rejectModal, setRejectModal } = useStateContext();

  const [html, setHtml] = useState("");

  const user = AuthService.getCurrentUser();

  const [approvedDayslist, setApprovedDayslist] = useState([]);

  const fetchEmpLeaveDays = () => {
    const payload = {
      reqid: user.role === "1" ? selectedRowData.rid : selectedRowData.reqid,
      empid: user.role === "1" ? selectedRowData.emp_id : selectedRowData.empid,
    };

    if (
      Object.values(payload).filter((value) => value !== undefined).length > 0
    ) {
      LeaveHistoryService.getEmpLeaveDays(payload)
        .then((resp) => {
          if (resp.data.length > 0 && Array.isArray(leaveDays)) {
            // Merge API data with leaveDays using dateval
            const merged = leaveDays.map((ld) => {
              const apiItem = resp.data.find((api) => api.date === ld.dateval);
              return apiItem ? { ...ld, ...apiItem } : { ...ld };
            });
            setApprovedDayslist(merged);
          } else if (resp.data) {
            setApprovedDayslist(
              Array.isArray(leaveDays)
                ? leaveDays.map((item) => ({
                    ...item,
                    date: item.dateval,
                    ishaifDay: item.workday === "0.5" ? "1" : "0",
                    ispaid: "0",
                    isGoodWill: "0",
                    isApproved: "0",
                  }))
                : []
            );
          }
        })
        .catch((e) => console.log(e));
    }
  };

  useEffect(() => {
    fetchEmpLeaveDays();
  }, [selectedRowData, leaveDays]);

  const onChange = (e) => {
    setHtml(e.target.value);
  };

  const rejectLeaveRequest = () => {
    const userRoles = ["1", "2", "4"];
    const payload = {
      rid: userRoles.includes(user.role)
        ? selectedRowData.rid
        : selectedRowData.reqid,
      emp_id: userRoles.includes(user.role)
        ? selectedRowData.emp_id
        : selectedRowData.empid,
      roleid: user && user.role,
      isapproved: "2",
      approvedBy: user && user.empid,
      approvedDays: "0",
      isgoodwill: "0",
      isPartialApproved: "0",
      isprobation: "0",
      actionComment: html,
      approvedDayslist: [],
    };

    // console.log("payload", payload, selectedRowData);

    LeaveHistoryService.empLeaveRejectByRM(payload)
      .then((resp) => {
        if (resp.data) {
          setSuccess(true);
          setHeading("Leave Request Rejected Succesfully");
          fetchData();
          setRejectModal(false);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${
          rejectModal ? "sortByModal visible" : "sortByModal hidden"
        }`}
      >
        <div className="flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Reject leave request</span>
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Remark
              </label>
              <Editor value={html} onChange={onChange} />
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-reject" onClick={rejectLeaveRequest}>
              Reject
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectRequest;
